import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from '../config/fbConfig';
import { doc, updateDoc } from "firebase/firestore";
import '../styles/PersonalInformation.css';
import Back from '../images/back2.webp';
import Logo from '../images/hotel_logo.png';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';

const PersonalInformation = () => {
  const { user, userData } = useUserAuth();
  const [loading, setLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  // State variables for input fields
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [update, setUpdate] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
      });
    };

    // Set initial state only if userData exists and is valid
    if (userData) {
      setFirstName(userData.firstName || "");
      setLastName(userData.lastName || "");
      setPhone(userData.phone || "");
      setAddress(userData.address || "");
      setBankName(userData.bankName || "");
      setAccountName(userData.accountName || "");
      setAccountNumber(userData.accountNumber || "");
    }

    // Load image and update loading state
    loadImage(Back).then(() => setImageLoaded(true));
  }, [userData]);

  // Update loading state when both userData and image are ready
  useEffect(() => {
    if (userData !== null && imageLoaded) {
      setLoading(false);
    }
  }, [userData, imageLoaded]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setError("");
    setUpdate(true);

    if (!user || !userData || !userData.isActive) {
      setError("User data not available or account is inactive.");
      setUpdate(false);
      setShowModal(true);
      return;
    }

    const userDoc = doc(db, "users", user.uid);
    const updateData = {
      firstName,
      lastName,
      phone,
      address,
      bankName,
      accountName,
      accountNumber,
    };

    try {
      await updateDoc(userDoc, updateData);
      setUpdate(false);
      setSuccessMessage("Information updated successfully.");
      setShowModal(true);
    } catch (error) {
      setUpdate(false);
      setError("Update failed. Please try again.");
      setShowModal(true);
    }
  };

  if (loading) {
    return <Loader text={"LOADING"} />;
  }

  return (
    <>
      {update && <Loader text={"UPDATING"} />}
      <div className="top-elements row align-center space-between">
        <Link to="/home" className="back-link">
          <i className="fa-solid fa-arrow-left size3"></i>
        </Link>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <Link to="#" className="home-link" onClick={() => window.location.reload()}>
          <i className="fa-solid fa-rotate-right size4"></i>
        </Link>
      </div>
      <div className="login-page-items column align-center" style={{backgroundImage: `linear-gradient(#00000088, #0000005d), url(${Back})`}}>
        {userData && userData.isActive ? (
          <form className="form-items" onSubmit={handleUpdate}>
            <p className="login-heading align-center justify-center">PERSONAL INFORMATION</p>
            <div className="info-item">
              <span className="font-gold bold size5">Name</span><br />
              <input
                className="edit-field size4"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="First Name"
                required
              />
              <input
                className="edit-field size4"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Last Name"
                required
              />
            </div>
            <div className="info-item">
              <span className="font-gold bold size5">Phone</span><br />
              <input
                className="edit-field size4"
                type="text"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone Number"
                required
              />
            </div>
            <div className="info-item">
              <span className="font-gold bold size5">Address</span><br />
              <input
                className="edit-field size4"
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Address"
                required
              />
            </div>
            <div className="info-item">
              <span className="font-gold bold size5">Bank Details</span><br />
              <input
                className="edit-field size4"
                type="text"
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
                placeholder="Bank Name"
              />
              <input
                className="edit-field size4"
                type="text"
                value={accountName}
                onChange={(e) => setAccountName(e.target.value)}
                placeholder="Account Name"
              />
              <input
                className="edit-field size4"
                type="text"
                value={accountNumber}
                onChange={(e) => setAccountNumber(e.target.value)}
                placeholder="Account Number"
              />
            </div>
            <button type="submit" className="login-button personal-info-button">UPDATE</button>
          </form>
        ) : (
          <p className="male-female-stat align-center justify-center">
            {userData === null
              ? "Loading user data..."
              : "Your account is inactive. Contact support to activate."}
          </p>
        )}
      </div>
      {showModal && (
        <SuccessModal
          icon={error ? "xmark" : "check"}
          iconColor={error ? "red" : "green"}
          message={error || successMessage}
          onClose={() => {
            setError("");
            setSuccessMessage("");
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default PersonalInformation;